import { useEffect } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import { useACNavigate } from 'academy-common-lib/hooks/useACNavigate';
import { jsx as _jsx } from "react/jsx-runtime";
export const ScrollIntoView = ({
  id,
  children
}) => {
  const location = useLocation();
  const navigate = useACNavigate();
  useEffect(() => {
    if (location.hash === `#${id}`) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView();
        navigate(oldLocation => Object.assign({}, oldLocation, {
          hash: ''
        }), {
          replace: true
        });
      }
    }
  }, [id, location.hash, navigate]);
  return /*#__PURE__*/_jsx("section", {
    id: id,
    children: children
  });
};